import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectAnswers = (state) => state.answers

const answersSelector = createDraftSafeSelector(
  selectAnswers,
  (answers) => answers,
)

export const roleSelector = createDraftSafeSelector(
  selectAnswers,
  (answers) => {
    let resultRole = answers.learn.guardian.filter((gardianItem) => {
      return gardianItem.status === true
    })
    if (resultRole && resultRole.length > 0) {
      return resultRole[0]
    } else return []
  },
)

export const filledAnswerSelector = createDraftSafeSelector(
  selectAnswers,
  (answer) => {
    console.log('filledAnswerSelector', { answer })
  },
)

export default answersSelector
